// TODO: https://github.com/combinaut/sparkle/issues/32423 moves the remote_select feeds to { items, hasMore } and deletes this file with the last select2-format feed.

function toItem(result) {
  return Array.isArray(result?.children)
    ? { title: result.text, selectable: false, children: result.children.map(toItem) }
    : { title: result?.text, value: result?.id };
}

/** Returns a Select2 `{ results, pagination: { more } }` page as `{ items, hasMore }`, and any other reply unchanged. */
export function fromSelect2Page(reply) {
  if (!Array.isArray(reply?.results) || "items" in reply) {
    return reply;
  }

  return { items: reply.results.map(toItem), hasMore: reply.pagination?.more === true };
}
